const twelvedataGrowthEstimates = {
  current_quarter: -0.143,
  next_quarter: 0.109,
  current_year: 0,
  next_year: 0.075,
  next_5_years_pa: 0.01,
  past_5_years_pa: 0.041160002,
};
export default twelvedataGrowthEstimates;
